import React from 'react';
type SectionProps = {
  id?: string;
  emoji?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
  className?: string;
  children: React.ReactNode;
};
export function Section({
  id,
  emoji,
  eyebrow,
  title,
  subtitle,
  dark = false,
  className = '',
  children
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-12 sm:py-16 ${dark ? 'bg-navy-900 text-white' : 'bg-white text-navy'} ${className}`} data-id="element-193" data-mp="3kvqefvv6jh9q">
      <div className="mx-auto w-full max-w-3xl" data-id="element-194" data-mp="hdq44a25izsy">
        {(emoji || eyebrow) && <div className="flex justify-center" data-id="element-195" data-mp="2qn5u1608n4k">
            <span className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] ${dark ? 'bg-teal-500/15 text-teal-400' : 'bg-teal-50 text-teal-700'}`} data-id="element-196" data-mp="2nr8ady2k0gn">
              {emoji && <span aria-hidden="true" data-id="element-197" data-mp="106tzbzv0pkpo">{emoji}</span>}
              {eyebrow}
            </span>
          </div>}
        {title && <h2 className={`mt-4 text-center font-display text-[27px] font-black leading-[1.15] tracking-tight sm:text-4xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-198" data-mp="2ulh85zkpx4v8">
            {title}
          </h2>}
        {subtitle && <p className={`mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed sm:text-base ${dark ? 'text-white/70' : 'text-navy/70'}`} data-id="element-199" data-mp="33k2m1hf8vvpo">
            {subtitle}
          </p>}
        <div className={title || eyebrow ? 'mt-8' : ''} data-id="element-200" data-mp="3rc1az47m9pla">{children}</div>
      </div>
    </section>;
}